<template>
  <div id="footer">
      <div class="content">
          <div class="first-line line">
              <p>返利科技上海 徐汇区龙漕路200弄乙字一号</p>
              <p>返利科技北京  朝阳区东三环北路38号院3号楼</p>
              <p>返利科技广州  越秀区大塘街道东风中路515号东照大厦</p>
          </div>
          <div class="sec-line line">
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402000127" target="_blank"><img src="https://static2.51fanli.net/webapp/images/app/corp/common/footer_wj.png" alt=""></a>
              <a href="http://www.shjbzx.cn/" target="_blank"><img src="https://static2.51fanli.net/webapp/images/app/corp/common/footer_zx.png" alt=""></a>
              <img src="https://static2.51fanli.net/webapp/images/app/corp/common/footer-tel.png" alt="">
              <a href="https://www.12377.cn/" target="_blank"><img src="https://static2.51fanli.net/webapp/images/app/corp/common/footer_zq.png" alt=""></a>
          </div>
          <div class="third-line line">
              <p>Copyright © 返利网 2006-2021, All Rights Reserved.   </p>
              <!-- <p>沪ICP备08109440.互联网药品信息服务资格证书（沪）-非经营性-2021-0027  </p> -->
              <!-- <p>隐私条款</p> -->
          </div>

      </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  components: {

  },
}
</script>

<style lang="less" scoped>
    #footer {
        font-size: 40px;
        display: flex;
        background: #F6F6F6;
        align-items: center;
        justify-content: center;
        .content {
            padding: 80px 0;
            width: 1140px;
            .line {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 24px;
            }
            .first-line {
                p {
                    font-size: 16px;
                    color: #999;
                }
                padding-bottom: 23px;
                border-bottom: 1px solid #e6e6e6;
            }
            .sec-line {
                img {
                }
            }
            .third-line {
                p {
                    font-size: 16px;
                    color: #999;
                    text-align: center;
                    width: 100%;
                }
            }
        }
    }
</style>
